var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 49,
    viewBox: "0 0 42 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1968 10.2868C34.4231 10.2868 35.4172 9.32714 35.4172 8.14334C35.4172 6.95954 34.4231 5.99988 33.1968 5.99988C31.9705 5.99988 30.9763 6.95954 30.9763 8.14334C30.9763 9.32714 31.9705 10.2868 33.1968 10.2868Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0112 10.2868C28.2376 10.2868 29.2317 9.32714 29.2317 8.14334C29.2317 6.95954 28.2376 5.99988 27.0112 5.99988C25.7849 5.99988 24.7908 6.95954 24.7908 8.14334C24.7908 9.32714 25.7849 10.2868 27.0112 10.2868Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7463 10.2868C21.9727 10.2868 22.9668 9.32714 22.9668 8.14334C22.9668 6.95954 21.9727 5.99988 20.7463 5.99988C19.52 5.99988 18.5259 6.95954 18.5259 8.14334C18.5259 9.32714 19.52 10.2868 20.7463 10.2868Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4814 10.2868C15.7078 10.2868 16.7019 9.32714 16.7019 8.14334C16.7019 6.95954 15.7078 5.99988 14.4814 5.99988C13.2551 5.99988 12.261 6.95954 12.261 8.14334C12.261 9.32714 13.2551 10.2868 14.4814 10.2868Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4814 1.71289V7.45426M8.29578 1.71289V7.45426V1.71289ZM33.1967 1.71289V7.45426V1.71289ZM27.0111 1.71289V7.45426V1.71289ZM20.6669 1.78944V7.60736V1.78944Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2959 10.2868C9.52222 10.2868 10.5164 9.32714 10.5164 8.14334C10.5164 6.95954 9.52222 5.99988 8.2959 5.99988C7.06957 5.99988 6.07544 6.95954 6.07544 8.14334C6.07544 9.32714 7.06957 10.2868 8.2959 10.2868Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.4922H40.6512V43.2042C40.6512 45.6538 38.4307 47.7973 35.893 47.7973H5.75814C3.06186 47.7973 1 45.6538 1 43.2042V15.6453V15.4922Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80652 20.5447H36.8447V43.5106H4.80652V20.5447Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5139 27.511H29.5487V23.5303H33.5139V27.511ZM26.3766 27.511H22.4115V23.5303H26.3766V27.511ZM19.2394 27.511H15.2743V23.5303H19.2394V27.511ZM33.5139 33.8648H29.5487V30.0372H33.5139V33.8648ZM26.3766 33.8648H22.4115V30.0372H26.3766V33.8648ZM19.2394 33.8648H15.2743V30.0372H19.2394V33.8648ZM12.1022 33.8648H7.97852V30.0372H12.1022V33.8648ZM26.3766 40.3717H22.4115V36.391H26.3766V40.3717ZM19.2394 40.3717H15.2743V36.391H19.2394V40.3717ZM12.1022 40.3717H7.97852V36.391H12.1022V40.3717Z",
    stroke: "#5A5A5A",
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.4305H40.6512V8.37319C40.6512 5.9235 38.4307 3.78003 35.893 3.78003H5.75814C3.06186 3.78003 1 5.9235 1 8.37319V12.4305Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.08ae7590d61f58e9cf7c37a6a9057b25.svg";
export { ForwardRef as ReactComponent };